import React, { useState } from "react";
import './ServingMaster.css';
import {Empty,ConfigProvider} from "antd";
import EmptyData from "../../Assets/EmptyData.jpg";

import {
  Button,
  Table,
  Tag,
  Space,
  Card,
  Dropdown,
  Menu,
  message,
  Form,
  Input,
  InputNumber,
  Select,
  Row,
  Col,
  Divider,
  Typography
} from "antd";
import { FilterOutlined } from "@ant-design/icons";
const { Title, Text } = Typography;

const ServingMaster = () => {
 
const tableColumns = [
    { title: "S.no", dataIndex: "sno", key: "sno" },
    { title: "Name of the Material", dataIndex: "materialname", key: "materialname" },
    {
      title: "Serving Size (GMS)",
      children: [
        { title: "6m-3y", dataIndex: "sixToThreeGms", key: "sixToThreeGms" ,className: "custom-servingsize-header"},
        { title: "SAM", dataIndex: "sixToThreeGmsSAM", key: "sixToThreeGmsSAM",className: "custom-servingsize-header" },
        { title: "3y-6y", dataIndex: "threeToSixGms", key: "threeToSixGms",className: "custom-servingsize-header" },
        { title: "SAM", dataIndex: "threeToSixGmsSAM", key: "threeToSixGmsSAM",className: "custom-servingsize-header" },
        { title: "P|L|Aw", dataIndex: "plAwGms", key: "plAwGms" ,className: "custom-servingsize-header"},
      ],
    },
    {
      title: "Serving Days",
      children: [
        { title: "6m-3y", dataIndex: "sixToThreeDays", key: "sixToThreeDays",className: "custom-servingdays-header" },
        { title: "SAM", dataIndex: "sixToThreeDaysSAM", key: "sixToThreeDaysSAM",className: "custom-servingdays-header" },
        { title: "3y-6y", dataIndex: "threeToSixDays", key: "threeToSixDays",className: "custom-servingdays-header" },
        { title: "SAM", dataIndex: "threeToSixDaysSAM", key: "threeToSixDaysSAM",className: "custom-servingdays-header" },
        { title: "P|L|Aw", dataIndex: "plAwDays", key: "plAwDays" ,className: "custom-servingdays-header"},
      ],
    },
    {
      title: "Action",
      key: "action",align:"center",
      render: (_, record) => (
        <Space size="middle">
          <Button type="link" onClick={() => handleEdit(record)}>Edit</Button>
          <Button type="link" danger onClick={() => handleDelete(record)}>Delete</Button>
        </Space>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <Tag color={text === "Active" ? "green" : "red"}>{text}</Tag>
        
      ),
    },
  ];

  const [tableData, setTableData] = useState([
    {
      key: 1,
      sno: "01",
      materialname: "Puzhfi",
      sixToThreeGms: 90,
      sixToThreeGmsSAM: 92,
      threeToSixGms: 0,
      threeToSixGmsSAM: 150,
      plAwGms: 150,
      sixToThreeDays: 25,
      sixToThreeDaysSAM: 25,
      threeToSixDays: 25,
      threeToSixDaysSAM: 25,
      plAwDays: 25,
      status: "Active",
    },
     {
      key: 2,
      sno: "02",
      materialname: "Puzhfi",
      sixToThreeGms: 90,
      sixToThreeGmsSAM: 92,
      threeToSixGms: 0,
      threeToSixGmsSAM: 150,
      plAwGms: 150,
      sixToThreeDays: 25,
      sixToThreeDaysSAM: 25,
      threeToSixDays: 25,
      threeToSixDaysSAM: 25,
      plAwDays: 25,
      status: "Active",
    },
     {
      key: 3,
      sno: "03",
      materialname: "Puzhfi",
      sixToThreeGms: 90,
      sixToThreeGmsSAM: 92,
      threeToSixGms: 0,
      threeToSixGmsSAM: 150,
      plAwGms: 150,
      sixToThreeDays: 25,
      sixToThreeDaysSAM: 25,
      threeToSixDays: 25,
      threeToSixDaysSAM: 25,
      plAwDays: 25,
      status: "Inactive",
    },
  ]);

  const [filterStatus, setFilterStatus] = useState(null);
  const [isFormPage, setIsFormPage] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [form] = Form.useForm();
  const [currentMonth, setCurrentMonth] = useState("Sep");
  const cardItems= [
  { title: "Overall Servingmaterials", value: `${tableData.length} Pcs` },
  { title: "For the Month of", value: currentMonth },
];

  const exportToCSV = (data, filename = "ServingMaster_Data") => {
    if (!data || data.length === 0) {
      message.warning("No data to export");
      return;
    }
    const headers = Object.keys(data[0]);
    const csvRows = [headers.join(",")];
    data.forEach((row) => {
      const values = headers.map((h) => JSON.stringify(row[h] ?? ""));
      csvRows.push(values.join(","));
    });
    const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${filename}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const handleExport = () => {
    exportToCSV(tableData, "ServingMaster_Data");
  };

 const handleSave = (values) => {
  // Add new row to tableData
  const nextKey = tableData.length ? Math.max(...tableData.map(i => i.key)) + 1 : 1;
  const newRecord = {
    key: nextKey,
    sno: String(nextKey).padStart(2, "0"),
    ...values,
  };
  setTableData([...tableData, newRecord]);

  
  setCurrentMonth(values.indentMonth);

  setIsFormPage(false);
  setEditingRecord(null);
  form.resetFields();
  message.success("Saved successfully ✅");
};


  const handleEdit = (record) => {
    setEditingRecord(record);
    form.setFieldsValue(record);
    setIsFormPage(true);
  };

  const handleDelete = (record) => {
    setTableData(tableData.filter((item) => item.key !== record.key));
    message.success("Deleted successfully ❌");
  };

  const filteredData = filterStatus
    ? tableData.filter((item) => item.status === filterStatus)
    : tableData;

  const filterMenu = (
    <Menu
      onClick={(e) => setFilterStatus(e.key === "All" ? null : e.key)}
      items={[
        { key: "All", label: "All" },
        { key: "Active", label: "Active" },
        { key: "Inactive", label: "Inactive" },
      ]}
    />
  );


  if (isFormPage) {
    return (
      <div style={{ padding: "24px" }}>
        <h2 style={{display:"flex",textAlign:"center",justifyContent:"center",color:"#0166B1"}}>{editingRecord ? "Edit Serving Material" : "Add New Serving Material"}</h2>

        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="materialname" label="Name of the Material" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="indentMonth" label="Indent Month" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Divider orientation="left" style={{color:"#0166B1"}}>Serving Size</Divider>
          <Row gutter={12}>
            <Col span={4}><Form.Item name="sixToThreeGms" label="6m-3y" rules={[{ required: true }]}><InputNumber style={{ width: "100%" }} /></Form.Item></Col>
            <Col span={4}><Form.Item name="sixToThreeGmsSAM" label="6m-3y Sam" rules={[{ required: true }]}><InputNumber style={{ width: "100%" }} /></Form.Item></Col>
            <Col span={4}><Form.Item name="threeToSixGms" label="3y-6y" rules={[{ required: true }]}><InputNumber style={{ width: "100%" }} /></Form.Item></Col>
            <Col span={4}><Form.Item name="threeToSixGmsSAM" label="3y-6y Sam" rules={[{ required: true }]}><InputNumber style={{ width: "100%" }} /></Form.Item></Col>
            <Col span={4}><Form.Item name="adultsGms" label="Adults" rules={[{ required: true }]}><InputNumber style={{ width: "100%" }} /></Form.Item></Col>
            <Col span={4}><Form.Item name="plAwGms" label="P|L" rules={[{ required: true }]}><InputNumber style={{ width: "100%" }} /></Form.Item></Col>
          </Row>

          <Divider orientation="left" style={{color:"#0166B1"}}>Serving Days</Divider>
          <Row gutter={12}>
            <Col span={4}><Form.Item name="sixToThreeDays" label="6m-3y" rules={[{ required: true }]}><InputNumber style={{ width: "100%" }} /></Form.Item></Col>
            <Col span={4}><Form.Item name="sixToThreeDaysSAM" label="6m-3y Sam" rules={[{ required: true }]}><InputNumber style={{ width: "100%" }} /></Form.Item></Col>
            <Col span={4}><Form.Item name="threeToSixDays" label="3y-6y" rules={[{ required: true }]}><InputNumber style={{ width: "100%" }} /></Form.Item></Col>
            <Col span={4}><Form.Item name="threeToSixDaysSAM" label="3y-6y Sam" rules={[{ required: true }]}><InputNumber style={{ width: "100%" }} /></Form.Item></Col>
            <Col span={4}><Form.Item name="adultsDays" label="Adults" rules={[{ required: true }]}><InputNumber style={{ width: "100%" }} /></Form.Item></Col>
            <Col span={4}><Form.Item name="plAwDays" label="P|L" rules={[{ required: true }]}><InputNumber style={{ width: "100%" }} /></Form.Item></Col>
          </Row>

          <Divider orientation="left" style={{color:"#0166B1"}}>Per Consumer Serving Grams (OPTIONAL)</Divider>
          <Row gutter={12}>
            <Col span={4}><Form.Item name="pcsSixToThreeGms" label="6m-3y"><InputNumber style={{ width: "100%" }} /></Form.Item></Col>
            <Col span={4}><Form.Item name="pcsSixToThreeGmsSAM" label="6m-3y Sam"><InputNumber style={{ width: "100%" }} /></Form.Item></Col>
            <Col span={4}><Form.Item name="pcsThreeToSixGms" label="3y-6y"><InputNumber style={{ width: "100%" }} /></Form.Item></Col>
            <Col span={4}><Form.Item name="pcsThreeToSixGmsSAM" label="3y-6y Sam"><InputNumber style={{ width: "100%" }} /></Form.Item></Col>
            <Col span={4}><Form.Item name="pcsAdultsGms" label="Adults"><InputNumber style={{ width: "100%" }} /></Form.Item></Col>
            <Col span={4}><Form.Item name="pcsPlAwGms" label="P|L"><InputNumber style={{ width: "100%" }} /></Form.Item></Col>
          </Row>

          <Divider orientation="left" style={{color:"#0166B1"}}>Status</Divider>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item name="status" label="Status" rules={[{ required: true }]}>
                <Select>
                  <Select.Option value="Active">Active</Select.Option>
                  <Select.Option value="Inactive">Inactive</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item style={{ textAlign: "center", marginTop: 30 }}>
            <Button type="primary" htmlType="submit" style={{ marginRight: 16 }}>Save</Button>
            <Button onClick={() => setIsFormPage(false)}>Cancel</Button>
          </Form.Item>
        </Form>
      </div>
    );
  }

  
  return (
    <div>
      
     <Row gutter={16} style={{ marginBottom: 20, padding: 20 }} align="top" justify="space-between">
  <Col>
    <div style={{ display: "flex", gap: "16px", marginBottom: "24px" }}>
      {cardItems.map((item, index) => (
        <Card key={index} style={{ width: 200, height: 144, textAlign: "center" }} bodyStyle={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
          <div style={{ fontWeight: "bold", fontSize: 18, display: "flex", justifyContent: "center" }}>{item.title}</div>
          <div style={{ fontSize: 34, color: "#3498ff", fontWeight: 600, marginTop: 12, display: "flex", justifyContent: "center" }}>
            {item.value}
          </div>
        </Card>
      ))}
    </div>
  </Col>

  <Col>
    <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginBottom: "8px" }}>
      <Button type="primary" style={{ background: "#7E35FE", border: "1px" }} onClick={handleExport}>
        Export
      </Button>
      <Button
        type="primary"
        style={{ backgroundColor: "#05622C", border: "1px" }}
        onClick={() => {
          setIsFormPage(true);
          setEditingRecord(null);
          form.resetFields();
        }}
      >
        Add New SM
      </Button>
      <Dropdown overlay={filterMenu} placement="bottomRight">
       <Button type="default"  icon={<FilterOutlined />}  style={{ border: "1px solid #bfc5d2", color: "#3096E2" }}>Filters</Button>
      </Dropdown>
    </div>
  </Col>
</Row>

          <ConfigProvider
  renderEmpty={() => (
    <Empty
      image={EmptyData}
      description="No ServingMaster Data Available"
      imageStyle={{ height: 200 }}
    />
  )}
>
      
      
      <Table columns={tableColumns} dataSource={filteredData} 
      size="small"
      bordered/>
      
      </ConfigProvider>
    </div>
  );
};

export default ServingMaster;
